// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, string } from 'prop-types'
import clearForm from './clearForm'
import Import from './Import'
import Submit from './Submit'
import { Clear } from 'components/SearchAndSelect/Sets/common/ActionButtons'

const Buttons = props => {
  const {
    customImportHandler,
    highlightRows,
    highlightedRows,
    idRoot,
    sourceForm,
  } = props

  return (
    <div>
      <Submit
        idRoot={idRoot}
        sourceForm={sourceForm} />
      <Clear
        clearForm={clearForm}
        idRoot={idRoot}
        sourceForm={sourceForm} />
      {highlightRows &&
        <Import
          customImportHandler={customImportHandler}
          highlightedRows={highlightedRows}
          idRoot={idRoot} />
      }
    </div>
  )
}

Buttons.propTypes = {
  customImportHandler: func.isRequired,
  highlightRows: bool,
  highlightedRows: array.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default Buttons
